import { render } from "./template.vue?vue&type=template&id=d8f6a3a6&scoped=true"
const script = {}

import "./template.vue?vue&type=style&index=0&id=d8f6a3a6&scoped=true&lang=css"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8f6a3a6"]])

export default __exports__